module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "D3chart"
    }
  }, [_c('device-information', {
    attrs: {
      "dialog": _vm.dialog,
      "device": _vm.device
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1124f035","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Item/DeviceMapPivot.vue
// module id = 628
// module chunks = 1 6